import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Observable } from 'rxjs';

function mixinDisabled(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
            this._disabled = false;
        }
        get disabled() {
            return this._disabled;
        }
        set disabled(value) {
            this._disabled = coerceBooleanProperty(value);
        }
    };
}

function mixinInitialized(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
            this._isInitialized = false;
            this._pendingSubscribers = [];
            this.initialized = new Observable((subscriber) => {
                if (this._isInitialized) {
                    this._notifySubscriber(subscriber);
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this._pendingSubscribers.push(subscriber);
                }
            });
        }
        _markInitialized() {
            if (this._isInitialized) {
                throw Error('This directive has already been marked as initialized and ' +
                    'should not be called twice.');
            }
            this._isInitialized = true;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this._pendingSubscribers.forEach(this._notifySubscriber);
            this._pendingSubscribers = null;
        }
        _notifySubscriber(subscriber) {
            subscriber.next();
            subscriber.complete();
        }
    };
}

class ModalInjectableData {
    constructor(source) {
        this.source = source;
    }
}

/**
 * Source @angular/devkit-core
 * @url https://github.com/angular/angular-cli/blob/master/packages/angular_devkit/core/src/utils/strings.ts
 */
const STRING_DASHERIZE_REGEXP = /[ _]/g;
const STRING_DECAMELIZE_REGEXP = /([a-z\d])([A-Z])/g;
const STRING_CAMELIZE_REGEXP = /(-|_|\.|\s)+(.)?/g;
const STRING_UNDERSCORE_REGEXP_1 = /([a-z\d])([A-Z]+)/g;
const STRING_UNDERSCORE_REGEXP_2 = /-|\s+/g;
/**
 * Converts a camelized string into all lower case separated by underscores.
 *
 */
function decamelize(str) {
    return str.replace(STRING_DECAMELIZE_REGEXP, '$1_$2').toLowerCase();
}
/**
 Replaces underscores, spaces, or camelCase with dashes.
 */
function dasherize(str) {
    return decamelize(str).replace(STRING_DASHERIZE_REGEXP, '-');
}
/**
 Returns the lowerCamelCase form of a string.
 */
function camelize(str) {
    return str
        .replace(STRING_CAMELIZE_REGEXP, (_match, _separator, chr) => {
        return chr ? chr.toUpperCase() : '';
    })
        .replace(/^([A-Z])/, (match) => match.toLowerCase());
}
/**
 Returns the UpperCamelCase form of a string.
 */
function classify(str) {
    return str
        .split('.')
        .map((part) => capitalize(camelize(part)))
        .join('.');
}
/**
 More general than decamelize. Returns the lower\_case\_and\_underscored
 form of a string.
 */
function underscore(str) {
    return str
        .replace(STRING_UNDERSCORE_REGEXP_1, '$1_$2')
        .replace(STRING_UNDERSCORE_REGEXP_2, '_')
        .toLowerCase();
}
/**
 Returns the Capitalized form of a string
 */
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
}
function toWords(str) {
    return dasherize(str)
        .split('-')
        .map((c) => capitalize(c))
        .join(' ');
}

/**
 * Generated bundle index. Do not edit.
 */

export { ModalInjectableData, camelize, capitalize, classify, dasherize, decamelize, mixinDisabled, mixinInitialized, toWords, underscore };
